var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "createPolicyModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.create_policy"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createPolicy()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.create")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("b-validated-input-group-form-input", {
        attrs: {
          id: "identifier",
          label: this.$t("message.name"),
          "input-group-size": "mb-3",
          rules: "required",
        },
        model: {
          value: _vm.name,
          callback: function ($$v) {
            _vm.name = $$v
          },
          expression: "name",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }